<script setup lang="ts">
interface Props {
  icon: string
  size?: string
}

const props = withDefaults(defineProps<Props>(), { size: '20' })

const iconUrl = `url('${props.icon}')`
const sizePixel = `${props.size}px`
</script>

<template>
  <i class="icon" />
</template>

<style lang="scss" scoped>
  .icon {
    position: relative;
    display: inline-block;
    min-width: v-bind(sizePixel);
    max-width: v-bind(sizePixel);
    height: v-bind(sizePixel);
    vertical-align: middle;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: v-bind(sizePixel);
      height: v-bind(sizePixel);
      background-image: v-bind(iconUrl);
      background-position: center;
      background-repeat: no-repeat;
      background-size: v-bind(sizePixel);
    }
  }
</style>
